import CombineComponents from 'Widgets/CombineComponents/CombineComponents';
import MainContentSectionWidthProvider from './MainContentWidthContext';
const providers = [MainContentSectionWidthProvider];
const MainContentWidthContextProvider = CombineComponents(providers);
export default MainContentWidthContextProvider;
